import { useContext } from "react";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Status from "./status";
import Dashboard from "./dashboard";
import Certificate from "./certificate";
import AdminLogin from "./adminlogin";
import UploadPolicy from "./uploadpolicy";
import { createTheming } from "../utils/Theme";
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import SettingsContext from "../context/SettingsContext";
import CheckStatus from "./checkstatus";
import Scanner from "./scanner";

function App() {
  const themeSeeting = useContext(SettingsContext);
  const theme = createTheming({
    theme: themeSeeting.settings.theme,
  });

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<UploadPolicy />} />
          <Route path="/checkstatus" element={<CheckStatus />} />
          <Route path="/download-certificate" element={<Certificate />} />
          <Route path="/apb-scanner" element={<Scanner />} />

          {/* Auth Layout */}
          <Route
            path="/admin-signin"
            element={
              <AuthLayout>
                <AdminLogin />
              </AuthLayout>
            }
          />

          {/* Dashboard Layout */}
          <Route
            path="/admin-dashboard"
            element={
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            }
          />
          <Route path="/status" element={<Status />} />
        </Routes>
        <ToastContainer position="top-right" />
      </Router>
    </ThemeProvider>
  );
}

export default App;
